import { http } from '../../config/axios'

const getResumoFaturamento = (id: number): Promise<any> => {
  return http
    .get(`api/faturamento/${id}/resumo`)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getResumoFaturamento', error)
      throw Error(error.response.data)
    })
}

export default getResumoFaturamento;
